// https://stackoverflow.com/questions/10420352/converting-file-size-in-bytes-to-human-readable-string
export const formatFileSize = (value: number): string => {
	const i = Math.floor(Math.log(value) / Math.log(1024));
	if (i > 4) return '> 1 PB';
	return (value / Math.pow(1024, i)).toFixed(1) + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
};
